import {type Ref, type ComputedRef, ref, computed, onMounted, onBeforeUnmount, nextTick} from 'vue';

/** Tracks an element's width (rounded to nearest 100px) via ResizeObserver for responsive layout decisions */
export function useResponsiveElement(): {
  elementRef: Ref<HTMLElement | null>;
  width: ComputedRef<number>;
} {
  const elementRef = ref<HTMLElement | null>(null);
  const width = computed(() => {
    if (elementRef.value?.offsetWidth) {
      return Math.round(elementRef.value.offsetWidth / 100) * 100;
    }
    return 0;
  });
  
  let resizeObserver: ResizeObserver | null = null;
  
  async function setupObserver(): Promise<void> {
    await nextTick();
    if (window.ResizeObserver && elementRef.value instanceof Element) {
      const elementSize = ref(0);
      resizeObserver = new ResizeObserver(() => {
        elementSize.value = elementRef.value?.offsetWidth ?? 0;
      });
      resizeObserver.observe(elementRef.value);
    }
  }
  
  onMounted(setupObserver);
  onBeforeUnmount(() => {
    resizeObserver?.disconnect();
  });
  
  return {elementRef, width};
}
